import Page from './Index.vue';

export default Page;